module.exports = __webpack_public_path__ + "img/iconpdf.0f1de89d.svg";